<template>
  <div class="mt-5 field-layout-builder">
    <h3 class="font-weight-bold mb-2">詳細画面の設定</h3>
    <p class="text-description mb-4">
      <strong>非表示フィールド</strong> から <strong>表示エリア</strong> にフィールドをドラッグします。<br/>
      1行に最大3つのフィールドを配置できます。<br/>
      行をドラッグして上下に配置変更できます。
    </p>

    <el-row :gutter="20">
      <!-- CỘT TRÁI: DỮ LIỆU CHỜ (PALETTE) -->
      <el-col :span="6">
        <div class="panel-box shadow-sm border rounded bg-white">
          <div class="panel-header bg-light p-3 border-bottom font-weight-bold text-muted">
            <i class="fa fa-list mr-2"></i>非表示フィールド
          </div>
          <draggable
            v-model="hiddenFields"
            class="drag-area hidden-area p-2 vh-100"
            style="max-height: 600px; overflow-y: auto;"
            :group="{ name: 'fields', pull: true, put: true }"
            ghost-class="sortable-ghost-target"
            @change="emitUpdate"
          >
            <div
              class="field-item p-2 mb-2 bg-light border rounded text-truncate drag-handle"
              style="cursor: grab; font-size: 13px; border-style: dashed !important;"
              v-for="item in hiddenFields"
              :key="item.code"
              :title="item.label"
            >
              <i class="fa fa-arrows-alt mr-2 text-muted"></i>
              {{ item.label }}
            </div>
          </draggable>
        </div>
      </el-col>

      <!-- CỘT PHẢI: KHUNG ĐỰNG DỮ LIỆU (CANVAS) -->
      <el-col :span="18">
        <div class="panel-box shadow-sm border rounded bg-white">
          <div class="panel-header p-3 border-bottom font-weight-bold" style="background-color: #ecf5ff; color: #409EFF;">
            <i class="fas fa-th-large mr-2"></i>表示エリア（行ごとの分割）
          </div>
          
          <div class="layout-wrapper py-3 px-3" style="background: #fafafa; min-height: 500px;">
            
            <!-- Danh sách CÁC DÒNG (Kéo thả thay đổi thứ tự dòng) -->
            <draggable v-model="displayRows" handle=".row-drag-handle" @change="emitUpdate">
              <div v-for="(row, rIndex) in displayRows" :key="row.id" class="layout-row mb-3">
                <div class="row-container border rounded bg-white shadow-sm position-relative d-flex">
                  <!-- Tay nắm kéo thả dòng -->
                  <div class="row-drag-handle bg-light border-right d-flex align-items-center justify-content-center" style="width: 35px; cursor: move;" title="ドラッグして行の順序を変更する">
                    <i class="fa fa-grip-vertical text-muted"></i>
                  </div>
                  
                  <draggable 
                    v-model="row.fields" 
                    class="row-fields d-flex flex-wrap flex-grow-1 p-2" 
                    style="min-height: 80px;"
                    :group="{ name: 'fields' }" 
                    ghost-class="sortable-ghost-target"
                    handle=".drag-handle"
                    @change="onFieldChange($event, rIndex)"
                  >
                    <!-- Từng Thẻ Nằm Trong Dòng -->
                    <div
                      v-for="(item, index) in row.fields"
                      :key="item.code"
                      class="layout-item px-1 pb-2"
                      :style="{ width: getWidthPercentage(row.fields, index) }"
                    >
                      <div class="layout-item-inner border rounded h-100" style="transition: all 0.2s;">
                        <div class="item-header bg-light p-2 d-flex justify-content-between align-items-center drag-handle" style="cursor: grab;">
                          <span class="label text-truncate flex-grow-1" style="font-size: 13px; font-weight: 600;" :title="item.label">{{ item.label }}</span>
                          <i class="fa fa-times text-danger cursor-pointer ml-2" title="削除" @click="removeField(rIndex, item)"></i>
                        </div>
                      </div>
                    </div>
                    
                    <div v-if="row.fields.length === 0" class="text-muted w-100 d-flex justify-content-center align-items-center" style="font-size: 13px;">
                      空の行（自動的に削除されます）
                    </div>
                  </draggable>
                </div>
              </div>
            </draggable>

            <!-- Vùng Để TẠO DÒNG MỚI (Luôn nằm ở dưới cùng) -->
            <draggable v-model="newRowItem" class="new-row-area border p-4 text-center mt-3 rounded" style="background: rgba(64,158,255,0.05); border: 2px dashed #409EFF !important; cursor: pointer;" :group="{ name: 'fields' }" ghost-class="sortable-ghost-target" @change="onNewRowDrop">
              <div class="empty-placeholder text-primary">
                <i class="fa fa-layer-group fa-2x mb-2"></i>
                <h6 class="m-0 font-weight-bold">フィールドをここにドロップして新しい行を作成します</h6>
              </div>
            </draggable>

          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'field-display-layout',
  components: {
    draggable
  },
  props: {
    listField: { required: true },
    fieldDisplayLayout: { required: true }
  },
  data() {
    return {
      hiddenFields: [],
      displayRows: [],
      newRowItem: [],
      lastEmittedVal: null
    };
  },
  watch: {
    listField: {
      deep: true,
      immediate: true,
      handler() {
        this.initLayout();
      }
    },
    fieldDisplayLayout: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(this.lastEmittedVal)) return;
        this.initLayout();
      }
    },
  },
  methods: {
    initLayout() {
      let arrayField = Object.values(this.listField || {});
      if (!arrayField.length) return;

      let isNewFormat = this.fieldDisplayLayout && 
                        Array.isArray(this.fieldDisplayLayout) && 
                        this.fieldDisplayLayout.some(item => 'isHidden' in item || 'row' in item);
      let newHidden = [];
      let newDisplayRows = [];

      if (isNewFormat) {
          let existingLayoutMap = {};
          let rowMap = {};
          
          this.fieldDisplayLayout.forEach(item => {
              existingLayoutMap[item.code] = item;
              let field = arrayField.find(f => f.code === item.code);
              
              if (field) {
                  let storedWidth = item.width === 6 ? 8 : (item.width || 8);
                  let mappedField = {
                      code: field.code,
                      label: field.label,
                      type: field.type,
                      width: field.type === 'SUBTABLE' ? 24 : storedWidth,
                      row: typeof item.row !== 'undefined' ? item.row : null,
                      order: typeof item.order !== 'undefined' ? item.order : 9999
                  };
                  if (item.isHidden) {
                      newHidden.push(mappedField);
                  } else {
                      let mapIdx = mappedField.row !== null ? mappedField.row : 9999;
                      if (!rowMap[mapIdx]) {
                          rowMap[mapIdx] = [];
                      }
                      rowMap[mapIdx].push(mappedField);
                  }
              }
          });
          
          let sortedRows = Object.keys(rowMap).sort((a, b) => Number(a) - Number(b));
          sortedRows.forEach((rIndex, idx) => {
              let sortedFields = rowMap[rIndex].sort((a, b) => a.order - b.order);
              newDisplayRows.push({
                  id: 'row-' + idx + '-' + Date.now(),
                  fields: sortedFields
              });
          });
          
          arrayField.forEach(field => {
             if (!existingLayoutMap[field.code]) {
                  newHidden.push({ code: field.code, label: field.label, type: field.type, width: field.type === 'SUBTABLE' ? 24 : 8, row: null });
             }
          });
      } else if (this.fieldDisplayLayout && Array.isArray(this.fieldDisplayLayout) && this.fieldDisplayLayout.length > 0) {
          // Format cũ (trước khi có tính năng Kéo Thả): Mảng lưu trữ những trường bị ẩn.
          let hiddenCodes = this.fieldDisplayLayout.map(h => typeof h === 'object' ? h.code : h);
          let currentDisplayFields = [];
          
          arrayField.forEach(field => {
              if (hiddenCodes.includes(field.code)) {
                  newHidden.push({ code: field.code, label: field.label, type: field.type, width: field.type === 'SUBTABLE' ? 24 : 8, row: null });
              } else {
                  currentDisplayFields.push({ code: field.code, label: field.label, type: field.type, width: field.type === 'SUBTABLE' ? 24 : 8 });
              }
          });

          // Tự động phân bổ lại layout cho mảng hiển thị cũ, xếp vào dòng (mỗi dòng tối đa 3 field)
          let currentRow = [];
          
          currentDisplayFields.forEach(field => {
             let isFullWidth = field.type === 'SUBTABLE' || field.type === 'TEXTS';
             if (isFullWidth) {
                 if (currentRow.length > 0) {
                     newDisplayRows.push({
                         id: 'row-' + Date.now() + Math.random(),
                         fields: currentRow
                     });
                     currentRow = [];
                 }
                 newDisplayRows.push({
                     id: 'row-' + Date.now() + Math.random(),
                     fields: [{ ...field, width: 24 }]
                 });
             } else {
                 currentRow.push(field);
                 if (currentRow.length === 3) {
                     newDisplayRows.push({
                         id: 'row-' + Date.now() + Math.random(),
                         fields: currentRow
                     });
                     currentRow = [];
                 }
             }
          });
          
          if (currentRow.length > 0) {
              newDisplayRows.push({
                  id: 'row-' + Date.now() + Math.random(),
                  fields: currentRow
              });
          }
          
      } else {
          // Trạng thái mở module lần đầu tiên hoàn toàn (rỗng): Mặc định tất cả các trường nằm cất ở cột Trái
          arrayField.forEach(field => {
              newHidden.push({ code: field.code, label: field.label, type: field.type, width: field.type === 'SUBTABLE' ? 24 : 8, row: null });
          });
      }

      this.hiddenFields = newHidden;
      this.displayRows = newDisplayRows;
      this.newRowItem = [];
      
      this.$nextTick(() => {
        if (!this.lastEmittedVal) {
            this.emitUpdate();
        }
      });
    },
    onFieldChange(evt, rowIndex) {
       if (this.displayRows[rowIndex].fields.length === 0) {
           this.displayRows.splice(rowIndex, 1);
       }
       this.emitUpdate();
    },
    onNewRowDrop(evt) {
       if (evt.added) {
           let item = evt.added.element;
           this.newRowItem = [];
           this.displayRows.push({
               id: 'row-' + Date.now() + Math.random(),
               fields: [item]
           });
           this.emitUpdate();
       }
    },
    getWidthPercentage(fields, index) {
       let type = fields[index].type;
       if (type === 'SUBTABLE') return '100%';
       
       let chunks = [];
       let currentChunk = [];
       fields.forEach((f, i) => {
           if (f.type === 'SUBTABLE') {
               if (currentChunk.length > 0) { chunks.push(currentChunk); currentChunk = []; }
               chunks.push([i]);
           } else {
               currentChunk.push(i);
               if (currentChunk.length === 3) { chunks.push(currentChunk); currentChunk = []; }
           }
       });
       if (currentChunk.length > 0) chunks.push(currentChunk);
       
       for (let chunk of chunks) {
           if (chunk.includes(index)) {
               if (chunk.length === 1) return '100%';
               if (chunk.length === 2) return '50%';
               return '33.33%';
           }
       }
       return '33.33%';
    },
    removeField(rIndex, item) {
       let colIdx = this.displayRows[rIndex].fields.findIndex(f => f.code === item.code);
       if (colIdx !== -1) {
           this.displayRows[rIndex].fields.splice(colIdx, 1);
           this.hiddenFields.push(item);
           
           if (this.displayRows[rIndex].fields.length === 0) {
               this.displayRows.splice(rIndex, 1);
           }
           this.emitUpdate();
       }
    },
    emitUpdate() {
      let result = [];
      let orderIndex = 0;
      
      this.displayRows.forEach((row, rIndex) => {
         let chunks = [];
         let currentChunk = [];
         row.fields.forEach(f => {
            if (f.type === 'SUBTABLE') {
                if (currentChunk.length > 0) { chunks.push(currentChunk); currentChunk = []; }
                chunks.push([f]);
            } else {
                currentChunk.push(f);
                if (currentChunk.length === 3) { chunks.push(currentChunk); currentChunk = []; }
            }
         });
         if (currentChunk.length > 0) chunks.push(currentChunk);
         
         chunks.forEach(chunk => {
             let fw = chunk.length === 1 ? 24 : (chunk.length === 2 ? 12 : 8);
             chunk.forEach(f => {
                 result.push({
                     code: f.code,
                     label: f.label,
                     isHidden: false,
                     width: f.type === 'SUBTABLE' ? 24 : fw,
                     row: rIndex,
                     order: orderIndex++
                 });
             });
         });
      });
      
      this.hiddenFields.forEach(f => {
         let fw = f.width === 6 ? 8 : (f.width || 8);
         result.push({
             code: f.code,
             label: f.label,
             isHidden: true,
             width: f.type === 'SUBTABLE' ? 24 : fw,
             row: null,
             order: orderIndex++
         });
      });

      this.lastEmittedVal = result;
      this.$emit('update:fieldDisplayLayout', result);
    }
  }
};
</script>

<style scoped>
.layout-item-inner:hover {
  box-shadow: 0 4px 12px 0 rgba(0,0,0,.15);
  border-color: #66b1ff !important;
}
.row-container {
  transition: border 0.3s;
}
.row-container:hover {
  border-color: #409EFF !important;
}
.drag-handle {
  cursor: grab;
}

/* Định dạng CSS màu dải bóng ma kéo thả y hệt Kintone */
.sortable-ghost-target {
  background-color: #72d0f5 !important; /* Màu xanh lơ */
  border: 2px dashed #8b8b8b !important; /* Viền đứt khúc đen/xám nhạt */
  opacity: 0.8;
  height: 100%;
}
.sortable-ghost-target > div {
  visibility: hidden; /* Giấu nội dung thực tế đi để chỉ hiện cái hình chữ nhật màu khối */
}
</style>
